import { render, staticRenderFns } from "./FreeCreationCenter.vue?vue&type=template&id=480a56da&"
import script from "./FreeCreationCenter.vue?vue&type=script&lang=js&"
export * from "./FreeCreationCenter.vue?vue&type=script&lang=js&"
import style0 from "./FreeCreationCenter.vue?vue&type=style&index=0&id=480a56da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports